module.exports = __webpack_public_path__ + "media/images/new/background_great_camping_map@2x-fb0645ee752679bd4c1d1910d43a61a6.jpg";